<template>
    <div class="col-lg-5"  v-if="artistMedia.videos && artistMedia.photos">
        <aside class="artist__side mb-5">

            <img
                :src="getNameOfAvatar(artistMedia?.avatar?.file_path)"
                alt="Photo"
                class="artist__photo"
                width="350"
            >

            <h2 class="artist__ttl">Photos</h2>

            <ul class="artist__images">
                <li
                    v-for="(photo, i) in artistMedia.photos"
                    :key="photo.id"
                    class="artist__images-item"
                >
                    <img
                        :src="`/uploads/${photo.file.file_path}`"
                        @click="openLightbox(i)"
                        class="artist__images-img"
                    >
                </li>
            </ul>

            <h2 class="artist__ttl" v-if="artistMedia.video_links.length > 0">Videos</h2>

            <ul class="artist__videos" v-if="artistMedia.video_links.length > 0">
                <li v-for="(link, index) in artistMedia.video_links" :key="link.id">
                    <img
                        width="120"
                        :src="getThumbnail(link.link)"
                        @click="showCustomModal('videoModal', link.id)"
                    />
                    <VideoModal
                        :modal-id="getCustomModalId('videoModal', link.id)"
                        :video="getEmbedLink(link.link)"
                    />
                </li>
            </ul>
        </aside>


        <Lightbox
            :images="photoUrls"
            :index.sync="activePhoto"
            :visible.sync="lightboxVisible"
        />
    </div>
</template>

<script>
import { mapState } from "pinia";
import { useClientStore } from "../../stores/ClientStore";
import VideoModal from "./VideoModal.vue";
import ModalHandler from "../../mixins/ModalHandler";
import Lightbox from "./Lightbox.vue";

export default {
    name: "ArtistProfileMedia",
    components: { VideoModal, Lightbox },
    mixins: [ModalHandler],
    data() {
        return {
            lightboxVisible: false,
            activePhoto: 0,
        };
    },
    computed: {
        ...mapState(useClientStore, {
            artistMedia: "artistMedia",
        }),

        photoUrls() {
            if (!this.artistMedia.photos) return [];
            return this.artistMedia.photos.map(p => `/uploads/${p.file.file_path}`);
        }
    },
    methods: {
        openLightbox(index) {
            this.activePhoto = index;
            this.lightboxVisible = true;
        },

        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/svg/avatar.svg";
        },

        extractVideoId(link) {
            const match = link.match(/(?:v=|\/)([0-9A-Za-z_-]{11})/);
            return match ? match[1] : null;
        },
        getEmbedLink(link) {
            const videoId = this.extractVideoId(link);
            return videoId ? `https://www.youtube.com/embed/${videoId}` : link;
        },
        getThumbnail(link) {
            const videoId = this.extractVideoId(link);
            return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : link;
        }
    }
};
</script>

<style scoped>
.artist__images img {
    border-radius: 4px;
}

.artist__images {
    display: flex;
}

.artist__images-item {
    width: 90px;
    height: 160px;
    overflow: hidden;
    border-radius: 8px;
}

.artist__images-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
    display: block;
}

</style>
